import { render, staticRenderFns } from "./LandingInvesting.html?vue&type=template&id=68c40a24&scoped=true&"
import script from "./LandingInvesting.ts?vue&type=script&lang=ts&"
export * from "./LandingInvesting.ts?vue&type=script&lang=ts&"
import style0 from "./LandingInvesting.scss?vue&type=style&index=0&id=68c40a24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c40a24",
  null
  
)

export default component.exports